// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-expand-icon {
    margin-right: 0.2rem;
}

.editSearch__headerContainer {
    background-color: inherit;
    position: sticky;
    top: -1rem;
    padding-top: 1rem;
    z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/pages/userCollectedData/savedSearchesTab/SavedSearchesTab.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".accordion-expand-icon {\n    margin-right: 0.2rem;\n}\n\n.editSearch__headerContainer {\n    background-color: inherit;\n    position: sticky;\n    top: -1rem;\n    padding-top: 1rem;\n    z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
